module.exports = function(app) {
	app.directive('eprCardHeader', [function() {
		return {
			restrict: 'A',
			replace: true,
			template: require('directives/common/eprCardHeader.html'),

			scope: {
				headingText: '@eprCardHeader',
				showButton: '=?',
				buttonText: '@?',
				buttonImagePath: '@?',
				buttonImageAlt: '@?',
				buttonAction: '&?',
				buttonClass: '@?'
			},

			link: function(scope, elem) {
				scope.buttonAction = scope.buttonAction || function() {};
			}
		};
	}]);
};
